// Utility to get US state name from lat/lng using static boundary mapping
// Fallback approach that doesn't require Geocoding API
const US_STATE_BOUNDARIES = {
  'Alabama': { minLat: 30.144, maxLat: 35.008, minLng: -88.473, maxLng: -84.820 },
  'Alaska': { minLat: 51.214, maxLat: 71.365, minLng: -179.148, maxLng: -129.992 },
  'Arizona': { minLat: 31.332, maxLat: 37.004, minLng: -114.816, maxLng: -109.045 },
  'Arkansas': { minLat: 33.004, maxLat: 36.499, minLng: -94.617, maxLng: -89.644 },
  'California': { minLat: 32.534, maxLat: 42.009, minLng: -124.409, maxLng: -114.131 },
  'Colorado': { minLat: 36.992, maxLat: 41.003, minLng: -109.060, maxLng: -102.041 },
  'Connecticut': { minLat: 40.995, maxLat: 42.050, minLng: -73.727, maxLng: -71.786 },
  'Delaware': { minLat: 38.451, maxLat: 39.839, minLng: -75.788, maxLng: -75.049 },
  'Florida': { minLat: 24.396, maxLat: 31.000, minLng: -87.634, maxLng: -79.974 },
  'Georgia': { minLat: 30.356, maxLat: 35.000, minLng: -85.605, maxLng: -80.839 },
  'Hawaii': { minLat: 18.910, maxLat: 28.402, minLng: -178.334, maxLng: -154.806 },
  'Idaho': { minLat: 41.988, maxLat: 49.001, minLng: -117.243, maxLng: -111.043 },
  'Illinois': { minLat: 36.970, maxLat: 42.508, minLng: -91.513, maxLng: -87.494 },
  'Indiana': { minLat: 37.772, maxLat: 41.761, minLng: -88.097, maxLng: -84.784 },
  'Iowa': { minLat: 40.375, maxLat: 43.501, minLng: -96.639, maxLng: -90.140 },
  'Kansas': { minLat: 36.993, maxLat: 40.003, minLng: -102.051, maxLng: -94.588 },
  'Kentucky': { minLat: 36.497, maxLat: 39.147, minLng: -89.571, maxLng: -81.965 },
  'Louisiana': { minLat: 28.939, maxLat: 33.019, minLng: -94.043, maxLng: -88.817 },
  'Maine': { minLat: 42.977, maxLat: 47.459, minLng: -71.084, maxLng: -66.885 },
  'Maryland': { minLat: 37.911, maxLat: 39.723, minLng: -79.487, maxLng: -75.049 },
  'Massachusetts': { minLat: 41.237, maxLat: 42.887, minLng: -73.508, maxLng: -69.928 },
  'Michigan': { minLat: 41.696, maxLat: 48.306, minLng: -90.418, maxLng: -82.413 },
  'Minnesota': { minLat: 43.499, maxLat: 49.384, minLng: -97.239, maxLng: -89.491 },
  'Mississippi': { minLat: 30.173, maxLat: 34.996, minLng: -91.655, maxLng: -88.097 },
  'Missouri': { minLat: 35.995, maxLat: 40.613, minLng: -95.774, maxLng: -89.099 },
  'Montana': { minLat: 44.358, maxLat: 49.001, minLng: -116.050, maxLng: -104.039 },
  'Nebraska': { minLat: 39.999, maxLat: 43.001, minLng: -104.053, maxLng: -95.308 },
  'Nevada': { minLat: 35.001, maxLat: 42.002, minLng: -120.005, maxLng: -114.039 },
  'New Hampshire': { minLat: 42.697, maxLat: 45.305, minLng: -72.557, maxLng: -70.610 },
  'New Jersey': { minLat: 38.928, maxLat: 41.357, minLng: -75.559, maxLng: -73.894 },
  'New Mexico': { minLat: 31.332, maxLat: 37.000, minLng: -109.050, maxLng: -103.001 },
  'New York': { minLat: 40.496, maxLat: 45.015, minLng: -79.762, maxLng: -71.777 },
  'North Carolina': { minLat: 33.842, maxLat: 36.588, minLng: -84.322, maxLng: -75.460 },
  'North Dakota': { minLat: 45.935, maxLat: 49.000, minLng: -104.049, maxLng: -96.554 },
  'Ohio': { minLat: 38.403, maxLat: 41.977, minLng: -84.820, maxLng: -80.519 },
  'Oklahoma': { minLat: 33.615, maxLat: 37.002, minLng: -103.002, maxLng: -94.431 },
  'Oregon': { minLat: 41.991, maxLat: 46.299, minLng: -124.703, maxLng: -116.463 },
  'Pennsylvania': { minLat: 39.720, maxLat: 42.516, minLng: -80.519, maxLng: -74.690 },
  'Rhode Island': { minLat: 41.146, maxLat: 42.019, minLng: -71.862, maxLng: -71.120 },
  'South Carolina': { minLat: 32.034, maxLat: 35.215, minLng: -83.354, maxLng: -78.499 },
  'South Dakota': { minLat: 42.479, maxLat: 45.945, minLng: -104.057, maxLng: -96.436 },
  'Tennessee': { minLat: 34.983, maxLat: 36.678, minLng: -90.310, maxLng: -81.647 },
  'Texas': { minLat: 25.837, maxLat: 36.500, minLng: -106.645, maxLng: -93.508 },
  'Utah': { minLat: 36.997, maxLat: 42.001, minLng: -114.053, maxLng: -109.041 },
  'Vermont': { minLat: 42.727, maxLat: 45.016, minLng: -73.354, maxLng: -71.465 },
  'Virginia': { minLat: 36.541, maxLat: 39.466, minLng: -83.675, maxLng: -75.242 },
  'Washington': { minLat: 45.544, maxLat: 49.002, minLng: -124.848, maxLng: -116.915 },
  'West Virginia': { minLat: 37.201, maxLat: 40.638, minLng: -82.644, maxLng: -77.719 },
  'Wisconsin': { minLat: 42.491, maxLat: 47.309, minLng: -92.889, maxLng: -86.805 },
  'Wyoming': { minLat: 40.994, maxLat: 45.005, minLng: -111.056, maxLng: -104.052 }
};

export async function getStateFromLatLng(lat, lng) {
  // Find the state that contains the given coordinates
  for (const [stateName, bounds] of Object.entries(US_STATE_BOUNDARIES)) {
    if (lat >= bounds.minLat && lat <= bounds.maxLat && 
        lng >= bounds.minLng && lng <= bounds.maxLng) {
      return stateName;
    }
  }
  
  // If no exact match, find the closest state by distance to center
  let closestState = '';
  let minDistance = Infinity;
  
  for (const [stateName, bounds] of Object.entries(US_STATE_BOUNDARIES)) {
    const centerLat = (bounds.minLat + bounds.maxLat) / 2;
    const centerLng = (bounds.minLng + bounds.maxLng) / 2;
    const distance = Math.sqrt(Math.pow(lat - centerLat, 2) + Math.pow(lng - centerLng, 2));
    
    if (distance < minDistance) {
      minDistance = distance;
      closestState = stateName;
    }
  }
  
  return closestState;
}
